import React from 'react';
import { useTranslation } from 'react-i18next';
import { base } from '@sdxcorp/sdx-dds-gui-lib';

const {
  organisms: { LayoutContent },
  atoms: { Heading },
} = base;

interface LoadingProps {
  messageKey?: string;
}

export const Loading: React.FC<LoadingProps> = React.memo(({ messageKey = 'general.loading' }) => {
  const { t } = useTranslation();
  // @ts-ignore
  return <div>{t(messageKey)}</div>;
});

export const PageLoading: React.FC<LoadingProps> = React.memo(({ messageKey = 'general.loading' }) => {
  const { t } = useTranslation();
  // @ts-ignore
  const Msg = <Heading level="1">{t(messageKey)}</Heading>;
  return <LayoutContent>{Msg}</LayoutContent>;
});
